export default __webpack_public_path__ + "locales/ro/DownloadDialog.json?hash=69879164f26f9f63d0435a38aa210144";